import React from 'react';
import {
  BreadcrumbProps,
  SeparatorType,
} from 'libs/growth-platform-brand-system-v2/src/components/Breadcrumb';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { Link } from 'gatsby';
import { linkResolver, Subpath } from './linkResolver';

export const getBlogBreadcrumbs = (
  page: any,
  slugBase: any,
  locale: string,
): BreadcrumbProps => {
  const blogHome: {
    [key: string]: {
      title: string;
      url: string;
    };
  } = {
    fr: {
      title: 'Tous les articles',
      url: linkResolver({ slug: slugBase }, locale),
    },
    en: {
      title: 'Blog',
      url: linkResolver({ slug: slugBase }, locale),
    },
    es: {
      title: 'Contenido práctico',
      url: linkResolver({ slug: slugBase }, locale),
    },
  };

  let breadcrumbsData: Array<{
    url: string;
    title: string;
    key: string;
  }> = [];

  switch (page.__typename) {
    case 'DatoCmsBlogArticle':
      breadcrumbsData = [
        {
          url: linkResolver(
            { slug: page?.subCategory?.category?.slug },
            locale,
            '',
            Subpath.BlogArticles,
          ),
          title: page?.subCategory?.category?.hero?.[0]?.title,
          key: 'category',
        },
        {
          url: linkResolver(
            { slug: page?.subCategory?.slug },
            locale,
            '',
            Subpath.BlogArticles,
          ),
          title: page?.subCategory?.hero?.[0]?.title,
          key: 'subcategory',
        },
        {
          url: linkResolver(
            { slug: page.slug },
            locale,
            '',
            Subpath.BlogArticles,
          ),
          title: page.breadcrumbText || page.metaFields.title,
          key: 'article',
        },
      ];
      break;
    case 'DatoCmsSubCategoryPage':
      breadcrumbsData = [
        {
          url: linkResolver(
            { slug: page.category.slug },
            locale,
            '',
            Subpath.BlogArticles,
          ),
          title: page.category.hero?.[0]?.title,
          key: 'category',
        },
        {
          url: linkResolver(
            { slug: page?.slug },
            locale,
            '',
            Subpath.BlogArticles,
          ),
          title: page?.hero?.[0]?.title,
          key: 'subcategory',
        },
      ];
      break;
    default:
      breadcrumbsData = [
        {
          url: linkResolver(
            { slug: page.slug },
            locale,
            '',
            Subpath.BlogArticles,
          ),
          title: page.hero?.[0]?.title,
          key: 'category',
        },
      ];
      break;
  }

  if (!blogHome[locale]?.url) return { items: [] };
  return {
    items: [
      {
        node: (
          <BreadcrumbButton
            url={blogHome[locale].url}
            title={blogHome[locale].title}
          />
        ),
      },
      ...breadcrumbsData.map((breadcrumb, index) => ({
        node: (
          <BreadcrumbButton
            lastItem={index === breadcrumbsData.length - 1}
            index={index}
            key={breadcrumb.key}
            url={breadcrumb.url}
            title={breadcrumb.title}
          />
        ),
        separator: index === 0 ? SeparatorType.BAR : SeparatorType.CHEVRON,
      })),
    ],
  };
};

export interface IBreadcrumbButtonProps {
  url: string;
  title: string;
  lastItem?: boolean;
  index?: number;
}

const BreadcrumbButton = ({
  url,
  title,
  lastItem,
  index,
}: IBreadcrumbButtonProps) => {
  if (!lastItem)
    return (
      <ButtonTracking
        component={Link}
        to={url}
        section={`breadcrumb`}
        index={index}
        labelTracking={title}
      >
        {title}
      </ButtonTracking>
    );
  return <span>{title}</span>;
};
